import { toast } from "react-toastify";

export const toastOptions = {
  position: "bottom-left",
  autoClose: 2500,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  className: "toast",
  bodyClassName: "toast-body",
  progressClassName: "toast-progress",
};
